// extracted by mini-css-extract-plugin
export default {"social":"social--nz4tS","socialLink":"socialLink--a3ZRW","socialIcon":"socialIcon--ivCl7"};